// First Layer of riskAccumulation mutations
import {
  RISKACCUMULATION_LOADING,
  RISKACCUMULATION_SUCCESS,
  RISKACCUMULATION_FAIL,
  RISKACCUMULATIONLIST_LOADING,
  RISKACCUMULATIONLIST_SUCCESS,
  RISKACCUMULATIONLIST_FAIL
} from '@/store/types'

export const general = {
  [RISKACCUMULATION_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [RISKACCUMULATION_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [RISKACCUMULATION_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [RISKACCUMULATIONLIST_LOADING](state) {
    state.riskAccumulationList.init = 0
    state.riskAccumulationList.initErr = []
    state.riskAccumulationList.menu = {}
  },
  [RISKACCUMULATIONLIST_SUCCESS](state, data) {
    state.riskAccumulationList.init = 1
    state.riskAccumulationList.initErr = []
    state.riskAccumulationList.menu = data.menu
  },
  [RISKACCUMULATIONLIST_FAIL](state, error) {
    state.riskAccumulationList.init = 2
    state.riskAccumulationList.initErr = error
    state.riskAccumulationList.menu = {}
  }
}
